import { useEffect, useState } from "react";

/**
 * Debounces any value by `delay` ms.
 *
 * Sprint 2026-Feb — Used on master-list search boxes (Vendors, Clients,
 * Items etc.) so a fresh keystroke does not immediately fire another
 * server-side request. The value returned only updates once the user
 * has stopped typing for the given interval.
 *
 * Usage:
 *   const [search, setSearch] = useState("");
 *   const debouncedSearch = useDebouncedValue(search, 300);
 *   // Then pass `debouncedSearch` to usePaginatedList params.
 */
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
